import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6" style={{
      backgroundColor: 'var(--color-background)'
    }}>
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="mb-4">Sidan kunde inte hittas</p>
        <Link to="/" className="text-blue-500 hover:underline">
          Tillbaka till startsidan
        </Link>
      </div>
    </div>
  )
}

export default NotFound 